export const SAFETY_PROMPT_GUIDES = [
  {
    headline: "오늘의 점검 사항은 무엇인가요?",
    prompt: "오늘 예정된 굴착 작업 전 점검 사항을 체크리스트로 정리해줘",
  },
  {
    headline: "준비되면 말씀해 주세요.",
    prompt: "신규 작업자가 참여하는 아침 TBM 진행 순서와 질문을 만들어줘",
  },
  {
    headline: "안전한 하루를 함께 시작해요.",
    prompt: "오늘 타워크레인 인양 작업팀에게 전달할 5분 안전 브리핑을 작성해줘",
  },
  {
    headline: "현장의 목소리를 들려주세요.",
    prompt: "작업자들이 제기한 미끄럼과 자재 적치 문제를 개선대책으로 정리해줘",
  },
  {
    headline: "무엇을 확인해 드릴까요?",
    prompt: "이동식 크레인 작업계획서에서 반드시 확인할 항목을 알려줘",
  },
  {
    headline: "오늘도 무사고, 함께 만들어요.",
    prompt: "콘크리트 타설 작업의 주요 사고 예방수칙을 작업 순서대로 알려줘",
  },
  {
    headline: "위험 요소, 같이 찾아볼까요?",
    prompt: "고소작업대에서 천장 배관을 설치할 때 위험요인을 찾아줘",
  },
  {
    headline: "안전 점검, 도와드릴 준비 됐어요.",
    prompt: "외부 시스템비계 일일점검표에 들어갈 항목을 만들어줘",
  },
  {
    headline: "궁금한 법령이 있으신가요?",
    prompt: "작업발판과 안전난간 설치 기준이 나오는 법령 조문을 찾아줘",
  },
  {
    headline: "사고 사례가 궁금하신가요?",
    prompt: "비계 해체 중 추락한 중대재해 사례와 재발방지대책을 찾아줘",
  },
  {
    headline: "현장 리스크, 함께 분석해요.",
    prompt: "도심지 4m 굴착 작업의 붕괴와 장비 충돌 위험을 분석해줘",
  },
  {
    headline: "안전 관리의 든든한 파트너입니다.",
    prompt: "이번 주 현장 안전관리 중점사항을 공종별로 정리해줘",
  },
  {
    headline: "작업 전 체크리스트, 확인하셨나요?",
    prompt: "용접 화기작업 시작 전에 확인할 허가·소화·감시 항목을 정리해줘",
  },
  {
    headline: "오늘의 안전 브리핑, 시작할까요?",
    prompt: "철골 부재 인양 작업을 주제로 5분 안전 브리핑을 만들어줘",
  },
  {
    headline: "위험성 평가, 도와드릴게요.",
    prompt: "지하 슬래브 콘크리트 타설 작업의 위험성평가 초안을 만들어줘",
  },
  {
    headline: "어떤 현장을 점검하고 계신가요?",
    prompt: "아파트 신축 현장 골조공사 순회점검 항목을 알려줘",
  },
  {
    headline: "안전 규정, 빠르게 찾아드릴게요.",
    prompt: "밀폐공간 작업 전 산소농도 측정과 감시인 배치 기준을 찾아줘",
  },
  {
    headline: "현장에서 바로 물어보세요.",
    prompt: "강풍이 불 때 타워크레인 작업을 중지해야 하는 기준을 알려줘",
  },
  {
    headline: "사고 예방의 첫걸음, 여기서부터.",
    prompt: "지게차와 보행자 동선이 겹치는 현장의 사고 예방대책을 제안해줘",
  },
  {
    headline: "보호구 점검부터 법령 확인까지.",
    prompt: "그라인더 작업에 필요한 보호구와 관련 안전기준을 함께 알려줘",
  },
  {
    headline: "안전 교육 자료가 필요하신가요?",
    prompt: "신규 근로자 대상 추락사고 예방교육 자료의 목차와 핵심 내용을 만들어줘",
  },
  {
    headline: "유사 사고 사례를 검색해 드릴까요?",
    prompt: "이동식 크레인 인양물이 낙하한 유사 사고 사례를 찾아 비교해줘",
  },
  {
    headline: "오늘 현장, 이상 없으신가요?",
    prompt: "우천 후 굴착면과 임시전기 설비에서 우선 확인할 이상 징후를 알려줘",
  },
  {
    headline: "작업 허가서 검토가 필요하신가요?",
    prompt: "밀폐공간 작업허가서에서 누락되기 쉬운 항목을 검토해줘",
  },
  {
    headline: "위험 요인 하나라도 놓치지 않도록.",
    prompt: "철근 반입부터 조립까지 단계별 위험요인과 대책을 빠짐없이 정리해줘",
  },
  {
    headline: "안전은 디테일에서 완성됩니다.",
    prompt: "사다리 작업 안전수칙을 설치 각도와 상단 고정 방법까지 구체적으로 알려줘",
  },
  {
    headline: "한 발 앞선 예방이 최고의 대응입니다.",
    prompt: "다음 주 장마 예보에 대비한 건설현장 사전 점검계획을 세워줘",
  },
  {
    headline: "TBM 회의 준비, 도와드릴까요?",
    prompt: "외부비계 해체 작업의 핵심 위험 3가지를 반영한 TBM 시나리오를 만들어줘",
  },
  {
    headline: "MSDS 확인이 필요하신가요?",
    prompt: "에폭시 프라이머 작업 전에 MSDS에서 확인할 유해성과 응급조치를 알려줘",
  },
  {
    headline: "무엇이든 편하게 물어보세요.",
    prompt: "오늘 현장에서 가장 먼저 확인해야 할 안전사항을 함께 정리해줘",
  },
] as const;

export const SAFETY_HEADLINES = SAFETY_PROMPT_GUIDES.map(
  ({ headline }) => headline,
);

const SAFETY_PROMPT_BY_HEADLINE = new Map<string, string>(
  SAFETY_PROMPT_GUIDES.map(({ headline, prompt }) => [headline, prompt]),
);

export const getSafetyPromptExample = (headline: string) =>
  SAFETY_PROMPT_BY_HEADLINE.get(headline) ??
  "현장의 작업 상황을 알려주시면 필요한 안전 정보를 정리해드릴게요";

export const pickSafetyHeadline = (seed: string) => {
  let hash = 0;
  for (const char of seed) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return SAFETY_HEADLINES[hash % SAFETY_HEADLINES.length];
};

export const pickRandomSafetyHeadline = () =>
  SAFETY_HEADLINES[Math.floor(Math.random() * SAFETY_HEADLINES.length)];
